export class RangeModel<T = number> {
  constructor(
    public from: T,
    public to: T,
  ) {}
}
